
import { Localization } from "@viamap/viamap2-common";
import React from "react";
import { ActionTracker } from "./ActionTracker";
import { GlassButton } from "src/components/GlassButtons";

export class GlobalErrorBoundary extends React.Component<{ children: React.ReactNode }, { hasError: boolean, message: string, stackTrace: string }> {
   constructor(props: { children: React.ReactNode }) {
      super(props);
      this.state = {
         hasError: false,
         message: "",
         stackTrace: ""
      };
   }

   static getDerivedStateFromError(error: Error) {
      console.log("GlobalErrorBoundary caught an error:", error);
      return { hasError: true, message: error.message, stackTrace: error.stack || "" };
   }

   componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
      ActionTracker.track("Error", "ErrorBoundary", "Default", {
         ErrorLocation: "GlobalErrorBoundary",
         ErrorMessage: error.message || undefined,
         StackTrace: error.stack || undefined,
         ComponentStack: errorInfo.componentStack || undefined,
      })
   }

   render() {
      if (this.state.hasError) {
         return <>
            <ADMErrorDisplay>
               <>
                  <h1>{Localization.getText("default.globalErrorBoundary.errorInfoMessage")}</h1>
                  <br />
                  <br />
                  <h4>
                     {Localization.getText("default.globalErrorBoundary.errorHelpMessage")}
                  </h4>
                  <code style={{ whiteSpace: "pre-wrap", marginTop: "1em", display: "block", opacity: 0.3, fontSize: "0.8rem" }}>
                     {this.state.stackTrace}
                  </code>
                  <br />
                  <GlassButton onClick={() => {
                     window.location.reload();
                  }}>{Localization.getText("Reload")}</GlassButton>
               </>
            </ADMErrorDisplay >
         </>
      }
      return this.props.children;
   }
}

export function ADMErrorDisplay({ children }: { children: JSX.Element | string }) {
   return (
      <div className="ErrorDisplay" style={{ outline: "1px solid red", padding: "2em", borderRadius: "8px", backgroundColor: "rgba(255, 0, 0, 0.1)" }}>
         {children}
      </div>
   )
}